import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/spotlight";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="常见问题"
              desc="关于内容来源、讨论方式与热度数据的说明，先看这里再开始围观。"
            />
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <p className="text-sm leading-relaxed text-foreground-600">
                还有其他疑问？欢迎通过底部表单留言，或在投稿邮箱中说明，编辑团队会尽快回应。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((item) => {
                const open = openId === item.id;
                return (
                  <div
                    key={item.id}
                    className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenId(open ? null : item.id)}
                      aria-expanded={open}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-600">
                        <i className={open ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}></i>
                      </span>
                    </button>
                    {open ? (
                      <div className="border-t border-background-200 px-5 py-4">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}